import React from "react";
import  './style/global.css'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Components/Login";
import ForgetPassword from "./Components/ForgetPassword";
import Sidebar from "./Components/Sidebar";

import UserManagement from "./Components/UserManagement";

import ContactManagement from "./Components/ContactManagement";
import SubAdminManagement from "./Components/SubAdmin";
import CategoryManagement from "./Components/CategoryManagement";
import PortfolioManagement from "./Components/PortfolioManagement";
import CommunityManagement from "./Components/CommunityManagement";
const App = () => {
  return (
    <Router>
      {/* Routes */}
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="/forget-passqword" element={<ForgetPassword />} />
        <Route path="/sidebar" element={<Sidebar />} />

        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/category-management" element={<CategoryManagement />} />
        <Route path="/contact-management" element={<ContactManagement />} />
        <Route path="/sub-admin-management" element={<SubAdminManagement />} />
        <Route path="/portfolio-management" element = {<PortfolioManagement/>}/>
        <Route path="/community-management" element = {<CommunityManagement/>}/>     
      </Routes>
    </Router>
  );
};

export default App;
